import { PlayerType } from '../../../../core/models/video';
import { IPALessonDto } from '../../model/dailySchedule';

export function useBuildPlayer(lesson: IPALessonDto | null) {
  if (!lesson) {
    return { token: '', player: '', timeline: [] };
  }

  const { defaultPlayer, sambatech_token, vimeoID, timeline } = lesson;

  let token = sambatech_token || '';
  let player: PlayerType = defaultPlayer || 'sambatech';

  if (vimeoID) {
    token = vimeoID;
    player = 'vimeo';
  }

  return { token, player, timeline };
}
